import _objectSpread from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import ExceptionPage from '@/components/exception/ExceptionPage';
import { mapState } from 'vuex';
export default {
  name: 'Exp403',
  components: {
    ExceptionPage: ExceptionPage
  },
  computed: _objectSpread(_objectSpread({}, mapState('setting', ['pageMinHeight'])), {}, {
    minHeight: function minHeight() {
      return this.pageMinHeight ? this.pageMinHeight + 'px' : '100vh';
    }
  })
};